<tm-bottom-panel
  class="mobile-menubar-panel"
  [isVisible$]="isVisible$"
  [title$]="dialogTitle$"
  [height]="height$ | async"
  [mobile]="true"
  (closed)="closeDialog()">
  <ng-content></ng-content>
</tm-bottom-panel>
